import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WixSDK from 'shared/utils/wix-sdk';
import { updatePremiumIntent } from 'shared/utils/premium-intent';
import { VIEW_MODES } from '@wix/wix-vod-constants/dist/common/view-modes';

import getVodSettings from 'shared/redux/server/actions/vod-settings/get';
import getExperiments from 'shared/redux/server/actions/experiments/get';

@connect(
  store => ({
    vodSettings: store.vodSettings,
    experiments: store.experiments,
  }),
  {
    getVodSettings,
    getExperiments,
  },
)
export default class PremiumIntentUpdater extends React.Component {
  static propTypes = {
    vodSettings: PropTypes.object,
    experiments: PropTypes.object,
    getVodSettings: PropTypes.func,
    getExperiments: PropTypes.func,
  };

  componentDidMount() {
    const { getVodSettings, getExperiments } = this.props;
    if (WixSDK.Utils.getViewMode() === VIEW_MODES.EDITOR) {
      getVodSettings();
      getExperiments();
    }
  }

  componentWillUpdate(nextProps) {
    const { vodSettings, experiments } = nextProps;
    const { isPremiumIntentUpdated } = this;

    if (
      isPremiumIntentUpdated ||
      _.isEmpty(experiments) ||
      _.isEmpty(vodSettings)
    ) {
      return;
    }

    const { biUserUploadedFiles } = vodSettings;

    updatePremiumIntent({
      hasUploadedVideos: biUserUploadedFiles,
    });

    this.isPremiumIntentUpdated = true;
  }

  isPremiumIntentUpdated = false;

  render() {
    return null;
  }
}
